import React, { useEffect, createElement } from 'react';
import AdvertorialRlt2 from '../components/AdvertorialRlt2';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq and gtag for TypeScript
declare global {
  interface Window {
    fbq: any;
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}
export function Rlt2Page() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your Pixel ID
    window.fbq('init', '893117086060970');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Red Light Therapy Investigation - RLT-2',
      content_category: 'Health',
      content_type: 'article'
    });
    // Initialize Google Tag Manager dataLayer FIRST
    window.dataLayer = window.dataLayer || [];
    window.gtag = function (...args: any[]) {
      window.dataLayer.push(args);
    };
    // Load gtag.js script dynamically
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17548177287';
    document.head.appendChild(gtagScript);
    // Configure Google Tag Manager after script loads
    gtagScript.onload = () => {
      window.gtag('js', new Date());
      window.gtag('config', 'AW-17548177287', {
        send_page_view: true
      });
    };
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking - UPDATED CUSTOM EVENTS
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18713" data-mp="btuu8pj4oyb1">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18714" data-mp="6soy0hq9eswr">
        <Helmet data-id="element-18715" data-mp="6s5fozwp62i7">
          <script async src="https://www.googletagmanager.com/gtag/js?id=AW-17548177287" data-id="element-18716" data-mp="6urnn0ni2k0y"></script>
          <script data-id="element-18717" data-mp="lnv5za8x11sq">
            {`
            window.dataLayer = window.dataLayer || []; 
            function gtag() {dataLayer.push(arguments);}
            gtag('js', new Date()); 
            gtag('config', 'AW-17548177287');
            gtag('event', 'conversion', {'send_to': 'AW-17548177287/xQtBCOLL2LsbEIffz69B'});
            `}
          </script>
          <title data-id="element-18718" data-mp="2rbvohmdl7ul">
            PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat
            Loss a Scam—Or Are Most Devices Just Built Wrong?
          </title>
          <meta property="og:title" content="PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat Loss a Scam—Or Are Most Devices Just Built Wrong?" data-id="element-18719" data-mp="36fwwjiosa1q1" />
          <meta property="og:description" content="A 3-month investigation with 14 volunteers revealed why most red light therapy devices fail to deliver clinical results. The difference isn't the wavelength—it's how the light is delivered to the fat cells." data-id="element-18720" data-mp="31ezi9h6w9rtt" />
          <meta property="og:type" content="article" data-id="element-18721" data-mp="2dpbz968huy39" />
          <meta property="og:url" content={window.location.href} data-id="element-18722" data-mp="2ih3jkz1247ky" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18723" data-mp="2iieletaxz59f" />
          <meta property="og:image:width" content="1200" data-id="element-18724" data-mp="2sf18zpunkaf5" />
          <meta property="og:image:height" content="630" data-id="element-18725" data-mp="2sdge1z4fepgr" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18726" data-mp="2wgmmndf0gsqe" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18727" data-mp="31ghh1qxzw0g7" />
          <meta name="twitter:title" content="PhD Exercise Physiologist Investigates: Is Red Light Therapy for Fat Loss a Scam—Or Are Most Devices Just Built Wrong?" data-id="element-18728" data-mp="31dv6rjjpz6ua" />
          <meta name="twitter:description" content="A 3-month investigation with 14 volunteers revealed why most red light therapy devices fail to deliver clinical results. The difference isn't the wavelength—it's how the light is delivered to the fat cells." data-id="element-18729" data-mp="172q1kaszimcu" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18730" data-mp="ps2umfc37xxa" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18731" data-mp="pq9mevltt5n6" />
        </Helmet>
        <AdvertorialRlt2 data-id="element-18732" data-mp="1ifyq5gpx7jsh" />
      </div>
    </HelmetProvider>;
}